import React from 'react';
import type { POStatus } from '../purchaseOrdersTypes';
import styles from './POFilters.module.css';

type TabKey = 'all' | POStatus;

interface POFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  activeTab: TabKey;
  onTabChange: (tab: TabKey) => void;
  tabCounts: Record<string, number>;
}

const tabs: { key: TabKey; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'draft', label: 'Draft' },
  { key: 'approved', label: 'Approved' },
  { key: 'sent', label: 'Sent' },
  { key: 'transit', label: 'Transit' },
  { key: 'partial', label: 'Partial' },
  { key: 'delayed', label: 'Delayed' },
  { key: 'done', label: 'Done' },
];

export const POFilters: React.FC<POFiltersProps> = ({
  searchQuery,
  onSearchChange,
  activeTab,
  onTabChange,
  tabCounts,
}) => {
  return (
    <div className={styles.container}>
      {/* Search Bar */}
      <div className={styles.searchWrapper}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          placeholder="Search by SKU, product name, or category..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      {/* Tabs */}
      <div className={styles.tabsRow}>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`${styles.tab} ${activeTab === tab.key ? styles.tabActive : ''}`}
              onClick={() => onTabChange(tab.key)}
            >
              {tab.label}({tabCounts[tab.key] || 0})
            </button>
          ))}
        </div>
        <button
          type="button"
          className={styles.viewAllBtn}
          onClick={() => onTabChange('all')}
          disabled={activeTab === 'all'}
        >
          View All
        </button>
      </div>
    </div>
  );
};
